import { useState } from "react";
import {
  Container,
  CssBaseline,
  Box,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../hooks/redux-hooks";
import { logout, resetPassword, resetDriverPassword } from "../slices/authSlice";
import {
  showNotification,
  NotificationType,
} from "../slices/notificationSlice";
import { useSearchParams, useNavigate } from "react-router-dom";

const ResetType = {
  Customer: 1,
  Driver: 2,
}

const ResetPassword = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  let type = searchParams.get("type") || ResetType.Customer;
  type = +type;

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    setError("");

    if (!newPassword || !confirmPassword) {
      setError(t("pleaseInputPassword"));
      return;
    }

    if (newPassword.length < 6) {
        setError(t("passwordTooShort"));
        return;
    }

    if (newPassword !== confirmPassword) {
      setError(t("passwordsNotMatch"));
      return;
    }

    if (!token) {
      setError(t("invalidResetToken"));
      return;
    }

    try {
      let result;
      if (type == ResetType.Driver) {
        result = await dispatch(resetDriverPassword({ token, newPassword })).unwrap();
        if (result) {
          dispatch(
            showNotification({
              message: t("resetPasswordSuccess"),
              type: NotificationType.Success,
            })
          );
          await dispatch(logout()).unwrap();
          navigate("/driver-login", { replace: true });
        }
      } else {
        result = await dispatch(resetPassword({ token, newPassword })).unwrap();
        if (result) {
          dispatch(
            showNotification({
              message: t("resetPasswordSuccess"),
              type: NotificationType.Success,
            })
          );
          await dispatch(logout()).unwrap();
          navigate("/login", { replace: true });
        }
      }
    } catch (error: any) {
      setError(error?.message || t("passwordResetFailed"));
    }
  };

  return (
    <Container maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          mt: 20,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography variant="h5" sx={{ mb: 3 }}>
          {t("setNewPassword")}
        </Typography>
        <TextField
          margin="normal"
          required
          fullWidth
          type="password"
          id="newPassword"
          label={t("newPassword")}
          name="newPassword"
          autoFocus
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          error={!!error}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          type="password"
          id="confirmPassword"
          label={t("confirmPassword")}
          name="confirmPassword"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          error={!!error}
          helperText={error}
        />
        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 3 }}
          onClick={handleSubmit}
        >
          {t("confirmReset")}
        </Button>
      </Box>
    </Container>
  );
};

export default ResetPassword;
